import { memo, type FunctionComponent, type ReactNode } from 'react';
// Skillmore UI Components
import { mapChunks } from '@empathco/ui-components/src/helpers/intl';
import ContentCard from '@empathco/ui-components/src/elements/ContentCard';
import InlineAlert from '@empathco/ui-components/src/elements/InlineAlert';
// local imports
import { getDelegator } from '../models/user';
import useCustomerSettings from '../config/customer';
import useVerifyUser from '../hooks/useVerifyUser';
import LeaderHeader from '../elements/LeaderHeader';
import Screen from '../v3/Screen';
import ManagerDashboard from '../components/ManagerDashboard';
import DashboardAnalytics from '../components/DashboardAnalytics';
import BoxTypography from '~/ui-components/mixins/BoxTypography';

const emptyWelcomeValues = {
  br: <br/>,
  par: (chunks?: ReactNode): ReactNode => (
    <BoxTypography variant="body1">
      {mapChunks(chunks)}
    </BoxTypography>
  )
};

const HRDashboardScreen: FunctionComponent = () => {
  const { DA_TABS, HAS_MANAGER_DASHBOARD } = useCustomerSettings();
  const { content, user } = useVerifyUser({ hr: true });
  const leader = getDelegator(user);

  return content || (
    <Screen withSettings>
      {leader ? <LeaderHeader leader={leader}/> : undefined}
      <ContentCard withoutTopMargin={Boolean(leader)}>
        {HAS_MANAGER_DASHBOARD || DA_TABS ? (DA_TABS && <DashboardAnalytics/>) || <ManagerDashboard hrbp/> : (
          <InlineAlert severity="info" message="hr.dashboard.empty_welcome" values={emptyWelcomeValues} flat/>
        )}
      </ContentCard>
    </Screen>
  );
};

export default memo(HRDashboardScreen);
